import * as React from 'react';

import { Input } from '@/components/ui/input';

type PhoneInputMode = 'cellphone' | 'landline-or-cellphone';

const formatBrazilPhone = (value: string, mode: PhoneInputMode = 'cellphone') => {
    const digits = value.replace(/\D/g, '').slice(0, 11);

    if (digits.length <= 2) {
        return digits;
    }

    if (mode === 'cellphone') {
        if (digits.length <= 7) {
            return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
        }

        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
    }

    if (digits.length <= 6) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }

    if (digits.length <= 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
    }

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

interface PhoneInputProps extends Omit<React.ComponentProps<typeof Input>, 'type' | 'value' | 'onChange'> {
    value: string;
    onValueChange: (value: string) => void;
    mode?: PhoneInputMode;
}

function PhoneInput({
    value,
    onValueChange,
    mode = 'cellphone',
    maxLength = 15,
    placeholder,
    inputMode = 'tel',
    ...props
}: PhoneInputProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onValueChange(formatBrazilPhone(event.target.value, mode));
    };

    return (
        <Input
            type='tel'
            value={value}
            onChange={handleChange}
            inputMode={inputMode}
            maxLength={maxLength}
            placeholder={placeholder ?? (mode === 'cellphone' ? '(11) 99999-9999' : '(11) 3333-3333')}
            {...props}
        />
    );
}

export { PhoneInput, formatBrazilPhone };
